import axios from "axios"
import router from "./router"
import store from "./store"

const apiCallHandler = axios.interceptors.response.use(
  response => response,
  error => {
  if (error.response?.status >= 500) {
    alert("サーバーエラーが発生しました。管理者にご連絡ください。")
    store.dispatch("clearAll")
    router.push({ name: "login"})
    return Promise.reject(error)

  } else {
    return Promise.reject(error)
  }
})

export default apiCallHandler
